import gql from 'graphql-tag'

export const fetchZonesSelect = () => {
	return {
		query: gql`
			{
				zones: organizations_zones(
					where: { active: { _eq: true } }
					order_by: { zone_name: asc }
				) {
					id
					zone_name
				}
			}
		`
	}
}
